import { initialStateType } from "../types/types";

let customLocale: string = ""
const localeSetLanguage = localStorage.getItem("language")
if (localeSetLanguage !== null) {
  customLocale = localeSetLanguage;
} else {
  customLocale = navigator.language.split("-")[0]
};

const initialState: initialStateType = {
  userName: "",
  token: null,
  refreshToken: null,
  cognitoUser: null,
  userPool: null,
  expTime: 0,
  useTimeZone: "+09:00",
  useSignal: false,
  usePresence: false,
  lastSendTime: "",
  language: customLocale,
  userIsSpread: false
};

export default initialState;
